
import { useEffect } from 'react';
import ProjectsHero from './components/ProjectsHero';
import ProjectsStats from './components/ProjectsStats';
import ProjectsGrid from './components/ProjectsGrid';
import ProjectsTestimonials from './components/ProjectsTestimonials';
import ProjectsCTA from './components/ProjectsCTA';
import Footer from '../home/components/Footer';
import ProjectsNavbar from './components/ProjectsNavbar';

export default function ProjectsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <ProjectsNavbar />
      <ProjectsHero />
      <ProjectsStats />
      <ProjectsGrid />
      <ProjectsTestimonials />
      <ProjectsCTA />
      <Footer />
    </div>
  );
}
